// src/features/tasks/components/TaskListPage/TasksDataGrid/hooks/useTasksDataGrid.js
import { useState, useMemo, useCallback } from 'react';
import { isTaskOverdue } from '../../../../utils/taskStateUtils';

export function useTasksDataGrid(tasks) {
  // Column visibility state
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    sort_priority: false,
  });

  // Custom sorting function for logical task priority
  const getTaskSortPriority = useCallback((task) => {
    if (isTaskOverdue(task)) {
      return 1;
    }
    
    switch (task.state) {
      case 'IN_PROGRESS':
        return 2;
      case 'PENDING':
        return 3;
      case 'ON_HOLD':
        return 4;
      case 'SCHEDULED':
        return 5;
      case 'COMPLETED':
        return 6;
      case 'CANCELLED':
        return 7;
      default:
        return 8;
    }
  }, []);

  // Add computed fields to tasks for sorting
  const tasksWithSortFields = useMemo(() => {
    return tasks.map(task => ({
      ...task,
      sort_priority: getTaskSortPriority(task),
      is_overdue: isTaskOverdue(task),
    }));
  }, [tasks, getTaskSortPriority]);

  // Get row styling based on task properties
  const getRowClassName = useCallback((params) => {
    const classes = [];
    
    if (isTaskOverdue(params.row)) {
      classes.push('row-overdue');
    }
    
    if (params.row.state === 'SCHEDULED') {
      classes.push('row-scheduled');
    }

    if (params.row.state === 'COMPLETED') {
      classes.push('row-completed');
    }

    if (params.row.state === 'CANCELLED') {
      classes.push('row-cancelled');
    }

    return classes.join(' ');
  }, []);

  return {
    columnVisibilityModel,
    setColumnVisibilityModel,
    tasksWithSortFields,
    getTaskSortPriority,
    getRowClassName,
  };
}